<template>
  <div class="card mb-3">
    <div class="card-body">
      <loading v-show="load"/>
      <div v-show="!load">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="mb-0 font-weight-bold">Configurações</h6>
          <button class="btn btn-dark btn-sm btn-secondary px-4" @click="salvarConfig">
            {{ atualizar ? 'Salvo' : 'Salvar' }}
          </button>
        </div>
        <hr>
        <div class="form-group mb-4">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <label class="mb-0">
                <b class="mr-1">Nova estrutura de impressão</b>
                <tooltip msg="Quando ativado, o estabelecimento passa a usar a nova estrutura de configuração de impressão."/>
              </label>
              <div class="small text-muted">Use esta opção para migrar gradualmente para o novo modelo.</div>
            </div>
            <a class="text-dark text-nowrap text-center text-decoration-none" href="javascript:"
               @click="config.migrado_legado = config.migrado_legado === 1 ? 0 : 1">
              <span class="small mr-2">{{ config.migrado_legado === 1 ? 'Ativado' : 'Desativado' }}</span>
              <img v-show="config.migrado_legado === 1" alt="Ativado" class="switch" src="../../../assets/icons/switch-on.svg"/>
              <img v-show="config.migrado_legado !== 1" alt="Desativado" class="switch" src="../../../assets/icons/switch-off.svg"/>
            </a>
          </div>
        </div>

        <div v-if="!isElectron" class="form-group mb-4">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <label class="mb-0">
                <b class="mr-1">Imprimir no navegador</b>
                <tooltip msg="Use para abrir o comprovante na tela quando o usuário não possuir impressora instalada."/>
              </label>
              <div class="small text-muted">Indicado para impressão via navegador/Bluetooth.</div>
            </div>
            <a class="text-dark text-nowrap text-center text-decoration-none" href="javascript:"
               @click="config.mobile_print = config.mobile_print === 1 ? 0 : 1">
              <span class="small mr-2">{{ config.mobile_print === 1 ? 'Ativado' : 'Desativado' }}</span>
              <img v-show="config.mobile_print === 1" alt="Ativado" class="switch" src="../../../assets/icons/switch-on.svg"/>
              <img v-show="config.mobile_print !== 1" alt="Desativado" class="switch" src="../../../assets/icons/switch-off.svg"/>
            </a>
          </div>
        </div>

        <div class="form-group mb-4">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <label class="mb-0">
                <b class="mr-1">Desmembrar itens</b>
                <tooltip msg="Quando ativado, imprime separadamente cada unidade do item."/>
              </label>
              <div class="small text-muted">Define se os itens devem ser separados por quantidade na impressão.</div>
            </div>
            <a class="text-dark text-nowrap text-center text-decoration-none" href="javascript:"
               @click="config.desmembrar_itens = config.desmembrar_itens === 1 ? 0 : 1">
              <span class="small mr-2">{{ config.desmembrar_itens === 1 ? 'Ativado' : 'Desativado' }}</span>
              <img v-show="config.desmembrar_itens === 1" alt="Ativado" class="switch" src="../../../assets/icons/switch-on.svg"/>
              <img v-show="config.desmembrar_itens !== 1" alt="Desativado" class="switch" src="../../../assets/icons/switch-off.svg"/>
            </a>
          </div>
        </div>

        <div v-if="isElectron" class="form-group mb-3">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <label class="mb-0">
                <b class="mr-1">Gestor principal</b>
                <tooltip msg="O gestor principal é o computador responsável por processar a fila de impressão dos pedidos."/>
              </label>
              <div class="small text-muted">Host atual: {{ hostName || 'Não identificado' }}</div>
            </div>
            <a class="text-dark text-nowrap text-center text-decoration-none" href="javascript:"
               @click="gestorPrincipal = gestorPrincipal === 1 ? 0 : 1">
              <span class="small mr-2">{{ gestorPrincipal === 1 ? 'Ativado' : 'Desativado' }}</span>
              <img v-show="gestorPrincipal === 1" alt="Ativado" class="switch" src="../../../assets/icons/switch-on.svg"/>
              <img v-show="gestorPrincipal !== 1" alt="Desativado" class="switch" src="../../../assets/icons/switch-off.svg"/>
            </a>
          </div>
        </div>

        <div v-if="isElectron" class="border-top pt-3">
          <div v-if="gestorPrincipal === 1" class="row no-gutters mb-2">
            <div class="col-12">
              <label class="mb-0 small">
                Impressora de comprovante padrão
                <tooltip msg="Define a impressora padrão usada para comprovantes enviados ao gestor principal."/>
              </label>
              <select v-model="config.id_impressora_comprovante" class="form-control">
                <option :value="null" disabled>Selecione uma impressora</option>
                <option v-for="impressora in impressorasRemotas" :key="impressora.id_impressora" :value="impressora.id_impressora">
                  {{ impressora.descricao }}
                </option>
              </select>
            </div>
          </div>

          <div v-if="gestorPrincipal !== 1">
            <div class="form-group mb-2">
              <label class="mb-0 small">
                Onde imprimir os comprovantes deste caixa?
                <tooltip msg="Voce pode usar a impressora local deste dispositivo ou enviar o comprovante para a impressora cadastrada no gestor principal."/>
              </label>
              <select v-model="receiptMode" class="form-control">
                <option value="remote">Enviar para o gestor principal</option>
                <option value="local">Neste dispositivo</option>
              </select>
            </div>

            <div v-if="receiptMode === 'remote'" class="row no-gutters">
              <div class="col-12 mb-2">
                <label class="mb-0 small">Impressora de comprovante cadastrada</label>
                <select v-model="config.id_impressora_comprovante" class="form-control">
                <option :value="null">Impressora padrão (default)</option>
                  <option v-for="impressora in impressorasRemotas" :key="impressora.id_impressora" :value="impressora.id_impressora">
                    {{ impressora.descricao }}
                  </option>
                </select>
                <div v-if="config.print_server" class="small text-muted mt-1">
                  Gestor principal atual: {{ config.print_server }}
                </div>
              </div>
            </div>

            <div v-else class="row no-gutters">
              <div class="col-12 mb-2">
                <label class="mb-0 small">
                  Impressora local
                  <a href="javascript:" @click="getPrinters()"><i class="fa fa-sync-alt ml-1"></i></a>
                </label>
                <select v-model="receiptLocal.device" class="form-control">
                  <option :value="''">Impressora padrão (default)</option>
                  <option v-for="p in printers" :key="p.displayName" :value="p.displayName">
                    {{ p.name }}{{ p.isDefault ? ' (Padrão)' : '' }}
                  </option>
                </select>
              </div>
              <div class="col-md-6 mb-2 pr-md-1">
                <label class="mb-0 small">Bobina</label>
                <select v-model="receiptLocal.tamanho_bobina_mm" class="form-control">
                  <option :value="80">80 mm</option>
                  <option :value="75">75 mm</option>
                  <option :value="70">70 mm</option>
                  <option :value="65">65 mm</option>
                  <option :value="58">58 mm</option>
                  <option :value="55">55 mm</option>
                </select>
              </div>
              <div class="col-md-6 mb-2 pl-md-1">
                <label class="mb-0 small">Fonte</label>
                <select v-model="receiptLocal.fonte_tamanho" class="form-control">
                  <option :value="7">Fonte 1</option>
                  <option :value="9">Fonte 2</option>
                  <option :value="11">Fonte 3</option>
                  <option :value="13">Fonte 4</option>
                  <option :value="15">Fonte 5</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <hr class="mb-3">
        <div v-if="!isComanda" class="form-group">
          <label class="mb-0 small">
            Impressão automática (delivery)
            <tooltip msg="Quando ativado, o gestor envia o pedido para impressão automaticamente ao aceitar."/>
          </label>
          <select v-model.number="config.print_automatico" class="form-control">
            <option :value="1">Sim</option>
            <option :value="0">Não</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from "@/components/commons/Tooltip";
import Loading from "../../gestor/loading";

const RECEIPT_STORAGE_KEY = 'receiptPrinterLocal';
const RECEIPT_MODE_KEY = 'receiptPrinterMode';
const PRINT_MODE_STORAGE_KEY = 'printMode';

export default {
  name: "ConfigSistemaNova",
  components: { Loading, Tooltip },

  props: {
    printers: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      token: localStorage.getItem('key'),
      load: false,
      atualizar: false,
      impressorasRemotas: [],
      gestorPrincipal: 0,
      receiptMode: 'remote',
      config: {
        id_impressao_config: null,
        print_automatico: 1,
        mobile_print: 0,
        desmembrar_itens: 1,
        print_server: '',
        id_impressora_comprovante: null,
        migrado_legado: 0
      },
      receiptLocal: {
        device: '',
        tamanho_bobina_mm: 70,
        fonte_tamanho: 13
      }
    };
  },

  methods: {
    getPrinters() {
      document.dispatchEvent(new CustomEvent('getPrinters'));
      this.$store.state.load = "Aguarde..";
      setTimeout(() => {
        this.$store.state.load = false;
        this.$swal("Impressoras sincronizadas com sucesso!");
      }, 2000);
    },

    carregarImpressorasRemotas() {
      this.$http.get('v2/impressao/impressoras')
        .then((response) => {
          const body = response.data || [];
          this.impressorasRemotas = Array.isArray(body) ? body : (body.data || []);
        }, () => {
          this.impressorasRemotas = [];
        });
    },

    carregarConfig() {
      this.load = true;
      this.carregarImpressorasRemotas();

      this.$http.get('v2/impressao/config')
        .then((response) => {
          const data = response.data || {};

          if (data && data.id_impressao_config) {
            this.config = {
              id_impressao_config: data.id_impressao_config || null,
              print_automatico: Number(data.print_automatico || 0),
              mobile_print: Number(data.mobile_print || 0),
              desmembrar_itens: Number(data.desmembrar_itens || 0),
              print_server: data.print_server || '',
              id_impressora_comprovante: data.id_impressora_comprovante ? Number(data.id_impressora_comprovante) : null,
              migrado_legado: Number(data.migrado_legado || 0)
            };
          }

          this.carregarReceiptLocal();
          this.sincronizarModoTela();
          this.load = false;

        }, () => {
          this.carregarReceiptLocal();
          this.sincronizarModoTela();
          this.load = false;
        });
    },

    carregarReceiptLocal() {
      const salvo = this.$helpers.parseJSONObject(localStorage.getItem(RECEIPT_STORAGE_KEY)) || {};
      const printMode = Number(localStorage.getItem(PRINT_MODE_STORAGE_KEY) || 1);

      this.receiptLocal = {
        device: salvo.device || '',
        tamanho_bobina_mm: Number(salvo.tamanho_bobina_mm || 70),
        fonte_tamanho: Number(salvo.fonte_tamanho || 13)
      };

      const receiptMode = localStorage.getItem(RECEIPT_MODE_KEY);
      this.receiptMode = receiptMode || ((printMode === 2 || this.receiptLocal.device) ? 'local' : 'remote');
    },

    sincronizarModoTela() {
      const printMode = Number(localStorage.getItem(PRINT_MODE_STORAGE_KEY) || 1);
      this.gestorPrincipal = this.config.print_server === this.hostName && printMode === 1 ? 1 : 0;
    },

    salvarConfig() {
      const isElectron = !!this.isElectron;
      const printMode = isElectron ? (this.gestorPrincipal === 1 ? 1 : (this.receiptMode === 'local' ? 2 : 1)) : 1;
      const payload = {
        print_automatico: Number(this.config.print_automatico || 0),
        mobile_print: Number(this.config.mobile_print || 0),
        desmembrar_itens: Number(this.config.desmembrar_itens || 0),
        print_server: payloadPrintServer(this.config.print_server, this.hostName, this.gestorPrincipal),
        id_impressora_comprovante: isElectron
          ? (this.gestorPrincipal === 1 || this.receiptMode === 'remote'
            ? (this.config.id_impressora_comprovante ? Number(this.config.id_impressora_comprovante) : null)
            : null)
          : null,
        migrado_legado: Number(this.config.migrado_legado || 0)
      };

      this.$store.state.load = true;
      this.$http.post('v2/impressao/config', payload)
        .then((res) => {
          this.$store.state.load = false;

          if (res.data && res.data.success) {
            const receiptLocal = {
              ...this.receiptLocal,
              device: this.receiptLocal.device || ''
            };

            if (isElectron) {
              localStorage.setItem(PRINT_MODE_STORAGE_KEY, printMode.toString());
            }

            if (isElectron && this.gestorPrincipal !== 1 && this.receiptMode === 'local') {
              localStorage.setItem(RECEIPT_STORAGE_KEY, JSON.stringify(receiptLocal));
            } else {
              localStorage.removeItem(RECEIPT_STORAGE_KEY);
            }

            if (isElectron && this.gestorPrincipal !== 1) {
              localStorage.setItem(RECEIPT_MODE_KEY, this.receiptMode);
            } else {
              localStorage.removeItem(RECEIPT_MODE_KEY);
            }

            const usaComprovanteLocal = isElectron && this.gestorPrincipal !== 1 && this.receiptMode === 'local';
            this.$store.commit('setImpressoraComprovanteLocal', usaComprovanteLocal
              ? { ...receiptLocal, modo: 'local' }
              : { modo: 'remote' });

            this.atualizar = true;
            this.$cache.remove('configImpressao');
            this.$swal("Configurações de impressão salvas com sucesso!").then(() => {
              window.location.reload();
            });
            return;
          }

          this.$swal((res.data || {}).msg || 'Não foi possível salvar as configurações de impressão.');

        }, (res) => {
          this.$store.state.load = false;
          this.$swal((res.data || {}).msg || 'Não foi possível salvar as configurações de impressão.');
        });
    }
  },

  computed: {
    hostName() {
      return ((window.gPConfigs || {}).host || '');
    },

    isComanda() {
      return this.$store.state.is_comanda;
    }
  },

  created() {
    this.carregarConfig();
  }
}

function payloadPrintServer(currentPrintServer, hostName, gestorPrincipal) {
  if (Number(gestorPrincipal) === 1) {
    return hostName || null;
  }

  if (currentPrintServer === hostName) {
    return null;
  }

  return currentPrintServer || null;
}
</script>
